import React from 'react';

const Suggestion = (props: any) => {
  return (
    <div data-testid="Suggestion-wrapper">
      {props.state?.length > 0 && (
        <div className="bg-white text-blue-700  font-semibold absolute top-16 text-sm shadow-lg sm:w-[300px] max-h-[300px] w-full overflow-scroll z-[10] p-2">
          {props.state?.map((item: any, index: number) => {
            return (
              <div key={index} className="flex items-center justify-between">
                <div className="w-[230px] break-words">{item.siteUrl}</div>
                <div
                  data-testid={`click-handler-${index}`}
                  onClick={() =>
                    props.onClickHandler && props.onClickHandler(item.id)
                  }
                  className="border py-1 px-2 border-blue-700 cursor-pointer my-1 rounded-sm hover:bg-[blue] hover:text-white"
                >
                  <i className="fa-solid fa-plus text-sm"></i>
                </div>
              </div>
            );
          })}
          <div>{props.loading}</div>
          {props.state?.length > 0 && (
            <div className="text-[green]">Similar website(s).</div>
          )}
        </div>
      )}
    </div>
  );
};

export default Suggestion;
